import { cn } from "@/lib/utils/utils"
import { Text } from "@/components/Primitives/Text/text"
import { Button } from "@/components/Primitives/Button/button"
import { AlertTriangle } from "lucide-react"

interface ErrorStateProps {
  message: string
  className?: string
  onRetry?: () => void
}

export function ErrorState({ message, className, onRetry }: ErrorStateProps) {
  return (
    <div
      className={cn(
        "p-6 bg-red-50 rounded-lg mb-4 flex flex-col items-center justify-center",
        className,
      )}
    >
      <div className="text-red-500 mb-4">
        <AlertTriangle size={32} />
      </div>
      <Text variant="paragraph" className="text-red-600 text-center mb-4">
        {message}
      </Text>
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="outline"
          className="border-red-300 text-red-600 hover:bg-red-100"
        >
          Intentar nuevamente
        </Button>
      )}
    </div>
  )
}
